import login_background from "./images/login_background.svg";
import empty_list from "./images/empty_list.svg";
import review_client from "./images/review_client.svg";
import admin_wallet_coin from "./images/admin_wallet_coin.png";

const Image_Prefix = {
  login_background,
  empty_list,
  review_client,
  admin_wallet_coin,
};

export default Image_Prefix;
